import React from "react";
import { IconButton, Menu, MenuItem } from "material-ui";
import MoreVertIcon from "material-ui-icons/MoreVert";
import { GetApp } from "material-ui-icons";
import { Unit } from "../../enums/Unit";

export default function ChartCardMenu(props) {
  let [ anchorEl, setAnchorEl ] = React.useState(null);
  
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  let { t } = props;
  
  return (
    <div>
      <IconButton
        aria-owns={anchorEl ? "simple-menu" : null}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            props.setUnit(false);
          }}
        >
          {t("No figures")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            props.setUnit(Unit.KWH);
          }}
        >
          kWh
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            props.setUnit(Unit.MWH);
          }}
        >
          MWh
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            props.toggleStacked();
          }}
        >
          {props.stacked ? t("Not stacked") : t("Stacked")}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            props.exportData();
          }}
        >
          <IconButton>
            <GetApp />
          </IconButton>
          {t("Download")}
        </MenuItem>
      </Menu>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/ChartCards/ChartCardMenu.js